import metaTags from '../components/meta-tags/definitions';

import LandingPage from '../areas/landing-page';

import Product from '../areas/product';
import ProductAlert from '../areas/product-alert';
import ProductCompare from '../areas/product-compare';

import Category from '../areas/category';
import CategoryIndex from '../areas/category-index';
import ProductCollection from '../areas/product-collection';
import ProductCollectionSitemap from '../areas/product-collection-sitemap';

import Services from '../areas/services';

import Store from '../areas/store';
import Brand from '../areas/brand';

import Info from '../areas/info';
import EditorialContent from '../areas/editorial-content';
import EditorialContentListing from '../areas/editorial-content-listing';

import Themes from '../areas/campaign/themes';
import Campaign from '../areas/campaign';

import GiftGuide from '../areas/gift-guide';
import NewsletterVerification from '../areas/newsletter-verification';
import Article from '../areas/article';

import Search from '../areas/search';

import TrackingSettings from '../areas/user/tracking-settings-loadable';
import Personalization from '../areas/user/personalization-loadable';
import UserProfile from '../areas/account/profile/user-profile-loadable';
import MyProfile from '../areas/account/profile/my-profile-loadable';

import CreateVerifiedShopReviewPage from '../areas/verified-shop-review/create-verified-shop-review-page';
import EditVerifiedShopReviewPage from '../areas/verified-shop-review/edit-verified-shop-review-page';

import {
  AccountManager,
  SignupConfirm,
  SettingsPage,
  EmailChangeConfirm,
  RecoverLinkSent,
  VerifyEmail,
} from '../areas/account';

import AlertUnsubscribePage from '../areas/alerts/unsubscribe';

import { ShopOfTheYearLandingPage } from '../areas/shop-of-the-year';

import PublicList from '../areas/public-list';

export default {
  start: {
    path: '/',
    component: LandingPage,
    showError: false,
    metaTags: metaTags.start,
    cacheControl: {
      maxAge: '1h',
      maxStale: '30m',
    },
  },
  newsletterVerify: {
    path: '/newsletter/verify',
    component: NewsletterVerification,
  },
  search: {
    path: '/search',
    component: Search,
    metaTags: metaTags.search,
  },
  services: {
    path: '/tjanster--cv1004',
    component: Services,
    metaTags: metaTags.services,
  },
  productAlert: {
    path: '*--p:id/alert',
    relativePath: '/alert',
    component: ProductAlert,
    metaTags: metaTags.productAlert,
  },
  productCompare: {
    path: '/compare/products/:productIds?',
    component: ProductCompare,
    metaTags: metaTags.productCompare,
  },
  product: {
    path: '*--p:id(\\d+)/:section(properties|reviews|statistics)?',
    component: Product,
    metaTags: metaTags.product,
    cacheControl: {
      maxAge: '12h',
      maxStale: '30m',
    },
  },
  category: {
    path: '*--c:id([sv]?\\d+)',
    component: Category,
    metaTags: metaTags.category,
    cacheControl: {
      maxAge: '4h',
      maxStale: '30m',
    },
  },
  categoryIndex: {
    path: '/categories',
    component: CategoryIndex,
    metaTags: metaTags.generic,
  },
  productCollection: {
    path: '/:type(c|o)/:slug',
    component: ProductCollection,
    metaTags: metaTags.productCollection,
    cacheControl: {
      maxAge: '4h',
      maxStale: '30m',
    },
  },
  productCollectionSitemap: {
    path: '/cm/:slug',
    component: ProductCollectionSitemap,
    metaTags: metaTags.productCollectionSitemap,
    cacheControl: {
      maxAge: '4h',
      maxStale: '30m',
    },
  },
  store: {
    path: '*--s:id(\\d+)/:section(reviews)?',
    component: Store,
    metaTags: metaTags.store,
  },
  brand: {
    path: '*--b:id(\\d+)',
    component: Brand,
    metaTags: metaTags.brand,
  },
  infoPage: {
    path: '*--i:id(\\d+)',
    component: Info,
    metaTags: metaTags.infoPage,
    cacheControl: {
      maxAge: '1h',
      maxStale: '30m',
    },
  },
  article: {
    path: '*--a:id(\\d+)',
    component: Article,
    metaTags: metaTags.article,
    cacheControl: {
      maxAge: '1h',
      maxStale: '30m',
    },
  },
  editorialContent: {
    path: '*--ec:id([\\w\\-]+)',
    component: EditorialContent,
    metaTags: metaTags.editorialContent,
  },
  editorialContentListing: {
    path: '/articles',
    component: EditorialContentListing,
    metaTags: metaTags.editorialContentListing,
  },
  prismicPreview: {
    path: '/prismic-preview',
    component: EditorialContent,
    metaTags: metaTags.editorialContent,
  },
  giftGuide: {
    // HACK: Must include all current running giftGuides, hardcoded
    path: '/campaigns/:name(gift-guide|another-gift-guide)/:list?',
    component: GiftGuide,
    metaTags: metaTags.campaign,
  },
  themes: {
    path: '/campaigns',
    component: Themes,
    metaTags: metaTags.campaign,
    cacheControl: {
      maxAge: '4h',
      maxStale: '30m',
    },
  },
  campaign: {
    path: '/campaigns/:name?',
    // Campaign pages uses AWS and elasticsearch internally for performance
    // and load reasons, we don't want to trigger a new fetch on url change.
    fetchStrategy: 'initial-only',
    component: Campaign,
    metaTags: metaTags.campaign,
    cacheControl: {
      maxAge: '4h',
      maxStale: '30m',
    },
  },
  signup: {
    path: '/signup',
    component: AccountManager,
    metaTags: metaTags.generic,
  },
  login: {
    path: '/login',
    component: AccountManager,
    metaTags: metaTags.generic,
    props: {
      recaptchaEnabled: false,
    },
  },
  forgotPassword: {
    path: '/forgot-password',
    component: AccountManager,
    metaTags: metaTags.generic,
    props: {
      subHeading: true,
    },
  },
  forgotPasswordChange: {
    path: '/forgot-password/change',
    component: AccountManager,
    props: {
      subHeading: true,
    },
    metaTags: metaTags.generic,
  },
  signupConfirm: {
    path: '/signup/confirm',
    component: SignupConfirm,
    metaTags: metaTags.generic,
  },
  profile: {
    path: '/account/profile/:section(reviews|settings|lists)?',
    component: MyProfile,
    metaTags: metaTags.generic,
  },
  user: {
    path: '/user/:id/:section(reviews|lists)?',
    component: UserProfile,
    metaTags: metaTags.userProfile,
  },
  settings: {
    path: '/account/settings',
    component: SettingsPage,
    metaTags: metaTags.generic,
  },
  emailChangeConfirm: {
    path: '/account/settings/email-change/confirm',
    component: EmailChangeConfirm,
    metaTags: metaTags.generic,
  },
  forgotPasswordEmailSent: {
    path: '/forgot-password/email-sent',
    component: RecoverLinkSent,
    metaTags: metaTags.generic,
  },
  trackingSettings: {
    path: '/privacy-settings',
    component: TrackingSettings,
    metaTags: metaTags.generic,
  },
  alertUnsubscribe: {
    path: '/alerts/unsubscribe',
    component: AlertUnsubscribePage,
    metaTags: metaTags.generic,
  },
  verifyEmail: {
    path: '/verify-email',
    component: VerifyEmail,
    metaTags: metaTags.generic,
  },
  shopOfTheYear: {
    path: '/shop-of-the-year',
    component: ShopOfTheYearLandingPage,
    metaTags: metaTags.shopOfTheYear,
  },
  shopOfTheYearWinners: {
    path: '/shop-of-the-year/:section',
    component: ShopOfTheYearLandingPage,
    metaTags: metaTags.shopOfTheYear,
  },
  shopOfTheYearCategory: {
    path: '/shop-of-the-year/:year/category/:id',
    component: ShopOfTheYearLandingPage,
    metaTags: metaTags.shopOfTheYearCategory,
  },
  personalization: {
    path: '/personalization',
    component: Personalization,
    metaTags: metaTags.generic,
  },
  createPurchaseReview: {
    path: '/purchase-review/create',
    component: CreateVerifiedShopReviewPage,
    metaTags: metaTags.generic,
  },
  editPurchaseReview: {
    path: '/purchase-review/edit',
    component: EditVerifiedShopReviewPage,
    metaTags: metaTags.generic,
  },
  publicList: {
    path: '/list/*--l:id',
    component: PublicList,
    metaTags: metaTags.publicList,
  },
};
